import React, { useState } from "react";
import { useTranslation, Trans } from "react-i18next";
import { Link, useLangNavigate } from "../i18n/LangContext";
import { sendEnquiry, trackEvent } from "../services/contactService";
import "../styles/QuickContact.css";

// The short homepage form: name, email, one message. The full form with
// project type and budget stays on /contact. Same EmailJS template, so the
// enquiry lands in the same inbox with project_type "Homepage quick form".
const QuickContact = () => {
  const { t } = useTranslation();
  const navigate = useLangNavigate();
  const [form, setForm] = useState({ name: "", email: "", message: "", website: "" });
  const [sending, setSending] = useState(false);
  const [error, setError] = useState("");

  const onChange = (e) => setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

  const onSubmit = async (e) => {
    e.preventDefault();
    // Honeypot: people never see the field, simple bots fill it in.
    if (form.website) return navigate("/thank-you");
    setSending(true);
    setError("");
    try {
      await sendEnquiry({ name: form.name, email: form.email, message: form.message, projectType: "Homepage quick form" });
      trackEvent("home-form-submit");
      navigate("/thank-you");
    } catch (err) {
      console.error("Error submitting form:", err);
      setError(t("home.quickForm.error"));
    } finally {
      setSending(false);
    }
  };

  return (
    <form className="quick-contact" onSubmit={onSubmit} aria-labelledby="quick-contact-title">
      <h3 id="quick-contact-title" className="quick-contact__title">{t("home.quickForm.title")}</h3>
      <p className="quick-contact__text">{t("home.quickForm.text")}</p>

      {error && <div className="alert alert-danger" role="alert">{error}</div>}

      <div className="row g-3">
        <div className="col-sm-6">
          <label htmlFor="qc-name" className="form-label">{t("home.quickForm.name")}</label>
          <input id="qc-name" name="name" type="text" className="form-control" autoComplete="name" value={form.name} onChange={onChange} required />
        </div>
        <div className="col-sm-6">
          <label htmlFor="qc-email" className="form-label">{t("home.quickForm.email")}</label>
          <input id="qc-email" name="email" type="email" className="form-control" autoComplete="email" value={form.email} onChange={onChange} required />
        </div>
        <div className="col-12">
          <label htmlFor="qc-message" className="form-label">{t("home.quickForm.message")}</label>
          <textarea id="qc-message" name="message" className="form-control" rows="3" placeholder={t("home.quickForm.messagePlaceholder")} value={form.message} onChange={onChange} required />
        </div>
      </div>

      <div className="quick-contact__hp" aria-hidden="true">
        <label htmlFor="qc-website">{t("home.quickForm.honeypot")}</label>
        <input id="qc-website" name="website" type="text" tabIndex={-1} autoComplete="off" value={form.website} onChange={onChange} />
      </div>

      <p className="form-consent mt-3">
        <Trans i18nKey="home.quickForm.consent" components={{ 1: <Link to="/privacy" /> }} />
      </p>

      <button type="submit" className="cta-primary quick-contact__submit" disabled={sending}>
        {sending ? t("home.quickForm.submitting") : t("home.quickForm.submit")}
      </button>
    </form>
  );
};

export default QuickContact;
